import {Controller} from "@hotwired/stimulus";
import {Collapse} from "bootstrap";

export default class extends Controller {
  static targets = ["logo", "addon"];

  connect() {
    // Initialize collapse instances for each addon if not already instantiated.
    this.addonTargets.forEach((addonElem) => {
      if (!Collapse.getInstance(addonElem)) {
        new Collapse(addonElem, {toggle: false});
      }
    });
    this.filter();
  }

  filter() {
    const selectedLogo = this.logoTargets.find((logo) => logo.checked);
    const selectedLogoId = selectedLogo ? selectedLogo.value : null;

    // For each addon with an applicable logo, show/hide using the Collapse API.
    this.addonTargets
      .filter((addonElem) => addonElem.dataset.hasOwnProperty("applicableLogo"))
      .forEach((addonElem) => {
        const collapseInstance = Collapse.getInstance(addonElem);
        if (selectedLogoId === addonElem.dataset.applicableLogo) {
          collapseInstance.show();
        } else {
          collapseInstance.hide();
        }
      });
  }
}
